import { Form, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

function alertClicked() {
  alert(
    "Welcome to our premium membership. You're one our VIPs now! Keep a look out for our notifications about your new exclusive songs!"
  );
}

function Checkout() {
  return (
    <>
      <div style={{display: "flex"}}>
        
      
      <Form
        style={{
          display: "flex",
          flexDirection: "column",
          gridColumn: 1,
          gridRow: 1,
          textAlign: "center",
        }}
      >
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control type="email" placeholder="Enter email" />
          <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>First and Last Name</Form.Label>
          <div style={{display: "flex"
            }}>
            <Form.Control type="First Name" placeholder="First Name" />
            <Form.Control type="Last Name" placeholder="Last Name" />
          </div>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicAddress">
          <Form.Label>Shipping Address</Form.Label>
          <Form.Control type="Address" placeholder="Address" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicAddress">
          <Form.Label>Payment Info</Form.Label>
          <Form.Control type="Credit Card" placeholder="Credit Card" />
          <Form.Control type="CVV" placeholder="CVV" />
          <Form.Control type="Expiration Month and Year" placeholder="Expiration Month and Year" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicCheckbox"></Form.Group>
        <Form.Group className="mb-3" controlId="formBasicCheckbox">
            
          <Form.Check type="checkbox" label="I accept the terms and services" />
          </Form.Group>
          </Form>
          
          <div
            className="card text-white bg-info mb-3"
            style={{
              //width: "100%",
              textAlign: "center"
            }}
          >
            <div className="card-header">$10/month</div>
            <div className="card-body">
              <h4 className="card-title">
                Subtotal: $10.00
              </h4>
              <h4>
                2-Month Commitment fee: $2.00
              </h4>
              <h4>
                20% discount: -$2.00
              </h4>
              <h3>
                Total: $10.00
              </h3>
                
              <small className="sideNote">  
                You may lose the songs that you don't favorite after your subscription has concluded
              </small>
            </div>
          </div>
        
        

      
        </div>
        <Link to="/DarkSoulMusic"><Button variant="primary" type="submit" action onClick={alertClicked}>
          Checkout
        </Button>
        </Link>
    </>
  );
}

export default Checkout;
